// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './erroralert.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const ErrorAlert = ({ errorText, errorImg, imgAlt, errorContainerStyle }) => {
  return (
    <div className='error-alert-container' style={errorContainerStyle}>
      <img src={errorImg} className='error-alert-icon' alt={imgAlt} />
      <label className='error-alert-label'>{errorText}</label>
    </div>
  )
}
